import * as React from "react";
import { forwardRef } from "react";
const SvgX = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 18, height: 16, viewBox: "0 0 18 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5.72368 0.000244141H0.138672L6.76055 8.70121L0.562276 16.0002H3.42606L8.11403 10.4798L12.2767 15.9495H17.8617L11.0475 6.99571L11.0595 7.01115L16.9267 0.101888H14.0629L9.70585 5.2328L5.72368 0.000244141ZM3.2215 1.52406H4.96018L14.7789 14.4256H13.0402L3.2215 1.52406Z", fill: "#020000" }));
const ForwardRef = forwardRef(SvgX);
export { ForwardRef as ReactComponent };
